import { Outlet, createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";

import TableSkeleton from "@/components/loadings/skeleton/TableSkeleton";
import type { ChildRouteContext } from "@/root";

import SettingsSidebar from "../../components/settings/SettingsSidebar";

export const Route = createFileRoute("/admin/_panel/_settings")({
  component: RouteComponent,
  beforeLoad: ({ context }) =>
    ({
      title: () => context.t("Settings", { ns: "core.shared" }),
      crumb: [
        {
          label: "Settings",
        },
      ],
      compactMenu: true,
      hideCrumb: true,
    }) satisfies ChildRouteContext,
});

function RouteComponent() {
  return (
    <div className="flex h-full flex-col">
      <div className="-m-6 h-full flex-1">
        <div className="flex h-full">
          <SettingsSidebar />
          <div className="flex min-w-0 flex-1 flex-col p-6">
            <Suspense fallback={<TableSkeleton />}>
              <Outlet />
            </Suspense>
          </div>
        </div>
      </div>
    </div>
  );
}
